module.exports = __webpack_public_path__ + "static/media/21.d18b6b71.jpg";